import * as types from '../mutation-types'
import Vue from 'vue'

const state = {
  subscriptionId: '',
  querySubscriptionStatus: false,
  subscriptionInfo: {
    subscription_id: 0,
    payment_method_id: '',
    payment_method_name: '',
    payment_logo: '',
    created_at: '',
    status: '',
    package_detail: {
      id: 0,
      name: ' ',
      type: 'subscription',
      price: 0,
      frequency: '',
      list_price: 0,
      device_count: 0,
      currency_code: 'USD',
      available_days: 0,
      frequency_interval: 0
    }
  }
}

const mutations = {
  setSubscriptionId (state, subscriptionId) {
    state.subscriptionId = subscriptionId
  },
  setQuerySubscriptionStatus (state, status) {
    state.querySubscriptionStatus = status
  },
  [types.RESET_SUBSCRIPTION] (state) {
    state.subscriptionInfo  = {
      subscription_id: 0,
        payment_method_id: '',
        payment_method_name: '',
        payment_logo: '',
        created_at: '',
        status: '',
        package_detail: {
        id: 0,
          name: ' ',
          type: 'subscription',
          price: 0,
          frequency: '',
          list_price: 0,
          device_count: 0,
          currency_code: 'USD',
          available_days: 0,
          frequency_interval: 0
      }
    }
  },
  [types.GET_SUBSCRIPTION] (state, data) {
    state.subscriptionInfo = data
  }
}

const actions = {
  getSubscription ({commit}) {
    commit(types.RESET_SUBSCRIPTION)
    return new Promise(function(resolve, reject) {
      Vue.http.get('api/topup-subscription-with-iTunes/get').then((response) => {
        resolve(response)
        if (response.data.code === 0) {
          commit(types.GET_SUBSCRIPTION, response.body.data)
        }
      })
    })
  }
}

export default {
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/subscribe.js